var map = {
	"./3d-2-s.jpg": 9749,
	"./3d-s.jpg": 3496,
	"./ai-2-s.jpg": 1078,
	"./ai-s.jpg": 6339,
	"./ar-2-s.jpg": 6953,
	"./ar-s.jpg": 3044,
	"./blockchain-2-s.jpg": 9658,
	"./blockchain-s.jpg": 8367,
	"./bpr-2-s.jpg": 2316,
	"./bpr-s.jpg": 4685,
	"./dt-2-s.jpg": 4128,
	"./dt-s.jpg": 3929,
	"./i4-2-s.jpg": 9839,
	"./i4-s.jpg": 8278,
	"./web-2-s.jpg": 738,
	"./web-s.jpg": 4663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9058;